// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import Chart from 'chart.js'
import Toasted from 'vue-toasted'
import VeeValidate from 'vee-validate'
import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'
import VueI18n from 'vue-i18n'
import messages from './localization'
import veeValidateMessagesIt from './localization/vee-validate-it'
import veeValidateMessagesEn from './localization/vee-validate-en'
import PrettyCheckbox from 'pretty-checkbox-vue'

Vue.use(PrettyCheckbox)

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'it',
  messages
})

Vue.use(Croppa)

const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  locale: 'it',
  dictionary: {
    en: veeValidateMessagesEn,
    it: veeValidateMessagesIt
  },
  strict: true,
  classes: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dancing' // control has been interacted with
  },
  events: 'input|blur',
  inject: false,
  validity: true,
  aria: true
}

Vue.use(VeeValidate, config)

Vue.use(Toasted, {
  theme: 'bubble',
  position: 'bottom-center',
  duration: 5000,
  router
})

Vue.config.productionTip = false
export const unsync = sync(store, router)

Chart.plugins.register({
  afterDraw: function(chart) {
    if (chart.data.datasets[0].data.length === 1 || chart.data.datasets[0].data.every(data => data === 0)) {
      // No data is present
      var ctx = chart.chart.ctx
      var width = chart.chart.width
      var height = chart.chart.height
      chart.clear()

      ctx.save()
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.font = "24px normal 'Helvetica Nueue'"
      ctx.color = '#000'
      ctx.fillStyle = '#FFF'
      ctx.fillText(chart.options.noDataLabel, width / 2, height / 2)
      ctx.restore()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js